<svg class="colorBar"></svg>
<div class="iaq-metric-bar-unit-container">
  <div>
    <span>{{this.lowDisplayValue}} </span>
    <span>{{this.unit}}</span>
  </div>
  <span>{{this.highDisplayValue}}</span>
</div>
